import React from 'react';
import ShapefileVisualizer from '../../global/ShapefileVisualizer/ShapefileVisualizer';
import styles from './shapefileFormAndPreview.module.scss';

interface GeoJSONFeatureCollection {
  type: 'FeatureCollection';
  features: Array<any>;
}

interface ShapefileFormAndPreviewProps {
  fieldBoundaryGeoJSON?: GeoJSONFeatureCollection;
  trialBoundaryGeoJSON?: GeoJSONFeatureCollection;
  abLineCoordinates?: [number, number][];
  brandColor?: string;
  children: React.ReactNode;
}

const ShapefileFormAndPreview: React.FC<ShapefileFormAndPreviewProps> = ({
  fieldBoundaryGeoJSON,
  trialBoundaryGeoJSON,
  abLineCoordinates,
  brandColor = '#007f66',
  children,
}) => {
  // Check if we have field boundary data to show
  const hasFieldBoundary = !!fieldBoundaryGeoJSON;

  return (
    <div className={styles['shapefile-form-preview']}>
      <div className={styles['form-section']}>{children}</div>

      <div className={styles['visualizer-section']}>
        {hasFieldBoundary ? (
          <ShapefileVisualizer
            fieldBoundaryGeoJSON={fieldBoundaryGeoJSON}
            trialBoundaryGeoJSON={trialBoundaryGeoJSON}
            abLineCoordinates={abLineCoordinates}
            brandColor={brandColor}
            height="400px"
            width="400px"
          />
        ) : (
          <div className={styles['placeholder-container']}>
            <p>Upload a field boundary shapefile to view visualization</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ShapefileFormAndPreview;
